export default __webpack_public_path__ + "static/media/practiceHub.f4507c35.png";